import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-scroll-to-top',
  templateUrl: './scroll-to-top.component.html',
  styleUrls: ['./scroll-to-top.component.scss'],
  imports: [NgClass, MatIcon],
})
export class ScrollToTopComponent implements OnInit, OnChanges {
  @Input()
  element: any;

  @Input()
  scrollPosition = 0;

  show = false;

  constructor() {}

  ngOnInit(): void {
    this.isVisible();
  }

  ngOnChanges() {
    this.isVisible();
  }

  isVisible() {
    if (this.scrollPosition <= 77 || !this.scrollPosition) {
      this.show = false;
    } else {
      this.show = true;
    }
  }

  onScrollToTop() {
    this.element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start',
      alignToTop: true,
    });
  }
}
